import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import HomePage from './pages/home-page';
import VisualCommunication from './pages/visual_communication';
import reportWebVitals from './reportWebVitals';

ReactDOM.render([
  <React.StrictMode>
    <HomePage />
  </React.StrictMode>
  ],
  document.getElementById('root')
);

reportWebVitals();

